import apiPath from 'config/api'
import { decodeToken } from './token'

import type { TokenPayload, UserType } from './token/interface'

export type TokenParam = string | null | undefined

export const getUserTypeEndpoint = (accessToken: TokenParam): string => {
  if (accessToken == null) {
    return apiPath.core.client
  }

  const tokenPayload = decodeToken<TokenPayload>(accessToken)

  switch (tokenPayload.userType) {
    case 'SYSTEM_ADMIN':
      return apiPath.core.systemAdmin
    case 'RESOURCE_ADMIN':
      return apiPath.core.admin
    case 'RESOURCE_OWNER':
      return apiPath.core.client
  }
}

export const checkUserType = (accessToken: TokenParam, userType: UserType) => {
  if (accessToken == null) {
    return null
  }

  const tokenPayload = decodeToken<TokenPayload>(accessToken)

  return tokenPayload.userType === userType
}

export const getUserId = (accessToken: TokenParam) => {
  if (accessToken == null) {
    return null
  }

  const tokenPayload = decodeToken<TokenPayload>(accessToken)

  return tokenPayload.userId
}
